import { useContext, useState } from 'react';
import './style.css'
import { Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { CadastroContext } from '../../../../contexts/CadastroContext';

const AsoEmpresaBeneficariosFinais = () => {
    const [selectedOption, setSelectedOption] = useState(true);
    const { cadastro, handleCadastroChange } = useContext(CadastroContext);
    const navigate = useNavigate();

    const handleContinuar = () => {
        cadastro.possuiBeneficiarios25Porcento = selectedOption;
        handleCadastroChange(cadastro);
        navigate("/aso/registro/funcao-empresa");
    }

    return (
        <div className='aso-beneficiario-body'>
            <div className='aso-beneficiario-title-container'>
                <div className='aso-beneficiario-title-text'>A sociedade tem beneficiários finais com pelo menos 25% de participação?</div>
            </div>
            <div className='aso-beneficiario-container'>
                <div className='aso-beneficiario-listagem-valores-container'>
                    <Button className="aso-beneficiario-botao" onClick={() => setSelectedOption(true)}>
                        <div className="aso-beneficiario-texto-botao">Sim</div>
                        <div className="aso-beneficiario-radio-wrapper">
                            <input type='radio' className='aso-beneficiario-radio-button' checked={selectedOption}/>
                        </div>
                    </Button>
                    <Button className="aso-beneficiario-botao" style={{ borderTop: '1px solid rgba(0, 0, 0, 0.2)' }} onClick={() => setSelectedOption(false)}>
                        <div className="aso-beneficiario-texto-botao">Não</div>
                        <div className="aso-beneficiario-radio-wrapper">
                            <input type='radio' className='aso-beneficiario-radio-button' checked={!selectedOption}/>
                        </div>
                    </Button>
                </div>
                <div className='continuar-button-container-mobile'>
                    <div className='continuar-button-container'>
                        <Button className='continuar-button' onClick={() => navigate('/aso/registro/faturamento-mensal-empresa')}>
                            Voltar
                        </Button>
                        <Button className='continuar-button' onClick={handleContinuar}>
                            Continuar
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AsoEmpresaBeneficariosFinais;